import React from 'react';
import Modal from "react-bootstrap/Modal";
import MergePdf from './MergePdf';
import PropTypes from 'prop-types';

/* istanbul ignore next */
const PdfMergePopup = (props) => {
    const { handleCancel, showPopUp, handleUploadPdfAction } = props;
    return (
        <Modal
            {...props}
            size="xl"
            className="topUpModal productskuListing"
            centered
            backdrop="static"
            show={showPopUp}
            onHide={handleCancel}
        >
            <div className="top_modal_header_container no_mrg mb-0">
                <span className="">Select Files</span>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={() => handleCancel()}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
            <div className="productList">
                <MergePdf isPopup={true} handleUploadPdfAction={handleUploadPdfAction} />
            </div>
        </Modal>
    );
};

PdfMergePopup.propTypes = {
    handleCancel: PropTypes.func,
    showPopUp: PropTypes.bool,
    handleUploadPdfAction: PropTypes.func
};

export default PdfMergePopup;